export type AuthMethod = "social" | "email" | "sso" | "sso-enforced";

export function isAuthMethod(value?: string): value is AuthMethod {
  if (!value) {
    return false;
  }

  return ["social", "email", "sso", "sso-enforced"].includes(value);
}
